import Amenity from '@customTypes/amenity';
import React, { Dispatch, SetStateAction } from 'react';
import Image from 'next/image';
import { slugify } from '@helpers/string';
import { getStaticIconsUrl } from '@utils/cloudflare';
import AmenityToImageNameMap from '@constants/amenityImageMap';
import BottomDrawerVariant from './BottomDrawerVariant';

type Props = {
  amenities: Amenity[];
  isAmenitiesDrawerOpen: boolean;
  setIsAmenitiesDrawerOpen: Dispatch<SetStateAction<boolean>>;
};

function AmenitiesBottomDrawer({
  amenities,
  isAmenitiesDrawerOpen,
  setIsAmenitiesDrawerOpen,
}: Props) {
  const getIcon = (item: Amenity): string => {
    const amenityImage = AmenityToImageNameMap[item.name];
    return getStaticIconsUrl(amenityImage);
  };

  return (
    <BottomDrawerVariant
      isOpen={isAmenitiesDrawerOpen}
      setIsOpen={setIsAmenitiesDrawerOpen}
      title="Amenities"
    >
      <div className="flex flex-col space-y-4 py-5 px-4 w-full">
        {amenities.map((amenity: Amenity) => (
          <div key={amenity.name} className="flex items-center space-x-4">
            <div className="relative h-5 w-6">
              <Image
                data-testid={slugify(`amenity-${amenity.description}`)}
                src={getIcon(amenity)}
                layout="fill"
                objectFit="contain"
                alt={amenity.description}
              />
            </div>

            <p className="-tracking-0.26 leading-6 text-base">{amenity.description}</p>
          </div>
        ))}
      </div>
    </BottomDrawerVariant>
  );
}

export default AmenitiesBottomDrawer;
